import { withViewPoint } from "../../hocs/withViewPoint";

const ViewPointWrapperUI = (props: any) => {
  return <>{props.children}</>;
};

const ViewPointCustomUI = withViewPoint(ViewPointWrapperUI);

const ViewPointUI = {
  Custom: ViewPointCustomUI,
  Mobile: (props: any) => <ViewPointCustomUI to="md" {...props} />,
  Desktop: (props: any) => <ViewPointCustomUI from="md" {...props} />,
};

export { ViewPointUI };
